import type { TOC } from '@ember/component/template-only';
import { PrismCard } from '@mylighthouse/prism-ember';

import styles from './review-card-loading.module.css';

interface HotelReviewsReviewCardLoadingSignature {
  Args: {};
}

const HotelReviewsReviewCardLoading: TOC<HotelReviewsReviewCardLoadingSignature> =
  <template>
    <PrismCard data-test-id="review-card-loading">
      <:header>
        <div class={{styles.loading-pulse}}></div>
      </:header>
      <:content>
        <div class={{styles.loading-pulse}}></div>
      </:content>
    </PrismCard>
  </template>;

export default HotelReviewsReviewCardLoading;
